import { domains } from 'config/env'
import { GRADE_BANDS } from 'store/reportsManager/constants'

export const FLAG_CORE_LESSON_COMPLETION_UPDATES =
  'feature_LEARN-27700_core-lesson-completion-updates'

export const FLAG_LEADER_DASHBOARD_REDESIGN =
  'feature_LEARN-25819_leaderDashboardRedesign'

export const PROGRAM_TITLES = {
  BPU: 'Bullying Prevention Unit Training',
  CPU: 'Child Protection Unit Training',
  HS: (
    <span>
      Second Step<sup>®</sup> High School
    </span>
  ),
  K8: (
    <span>
      Second Step<sup>®</sup> Grades K-8
    </span>
  ),
  SELA: (
    <span>
      Second Step<sup>®</sup> SEL for Adults
    </span>
  ),
  USER_PROGRESS: 'User Progress',
  INTERVENTIONS: 'Small Group Lesson Completion',
}

export const DROPDOWN_PROGRAMS = {
  BPU: {
    name: 'Bullying Prevention Unit Training',
    sortId: 2,
  },
  CPU: {
    name: 'Child Protection Unit Training',
    sortId: 3,
  },
  HS: {
    name: 'Grades 9-12',
    sortId: 1,
  },
  K8: {
    name: 'Grades K-8',
    sortId: 0,
  },
  SELA: {
    name: 'SEL for Adults',
    sortId: 4,
  },
}

export const PRACTICE_TYPES = {
  EDUCATOR_PRACTICES: {
    text: 'Educator Practices',
    url: 'educator-practices',
  },
  SCHOOLWIDE_PRACTICES: {
    text: 'Schoolwide Practices',
    url: 'schoolwide-practices',
  },
  STUDENT_ACTIVITIES: {
    text: 'Student Activities',
    url: 'student-activities',
  },
}

// Re-export GRADE_BANDS for backward compatibility
export { GRADE_BANDS }

export const CONTENTFUL_PROGRAM_LINK_INTERNAL_TITLE =
  'k8 admin quick links - explore lessons'
export const DASHBOARD_HEADER = 'Leader Dashboard'
export const PROGRAM_ERROR_MESSAGE = 'Program Title not Found'
export const PROGRAM_DROPDOWN_LABEL = 'Switch Program'
export const SCHOOL_OVERVIEW_LINK_TEXT = '< School Overview'
export const MANAGE_USERS_LINK_URL = `${domains.ADMIN_DOMAIN}/user-management`
